import _ from 'underscore';
import { getTruncatedWidenUrl, updateAssetUrlDimensions } from './widen-utils';
import { getItemsFromAccount, removeItemFromAccount, saveItemToAccount } from './consumer-account/storage-actions';

const swatchOrdering = () => {
  // console.log('\n\n\n*************************\n\nswatch-ordering.js ver: 2.0.7 \n\n*************************\n\n\n');

  _.templateSettings = {
    interpolate: /\{\{(.+?)\}\}/g,
  };

  const modalTemplate =
    `<div class="modal swatch-modal modal-visible" id="swatch-detail-modal" tabindex="0" aria-label="Swatch Detail Modal">
      <div class="modal-overlay"></div>
      <div class="modal-panel">
        <button type="button" class="close-btn" aria-label="Close Modal"></button>
        <div class="modal-inner">
          <div class="row">
            <div class="col">
              <div class="asset-loader">
                <div class="ldr-dual-ring"></div>
              </div>
              <div class="modal-image">
                <img src="{{ imageSrc }}" alt="{{ imageAlt }}">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gallery-modal-caption">
        <button class="caption-titlebar" aria-expanded="true">
          <div class="caption-title">
            <span class="icon"></span>
            About this Swatch
          </div>
        </button>
        <div class="caption-inner">
          <div class="caption-inner-left">
            <div class="caption-details-grid">
              <div>
                <div class="caption-header">Product</div>
                <div class="body-sm">{{ productName }}</div>
              </div>
              <div>
                <div class="caption-header">Color</div>
                <div class="body-sm">{{ colorName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;

  const modalTemplateVals = _.template(modalTemplate);
  if (document.querySelector('.swatch-modal-container') === null) {
    const body = document.querySelector('body');
    const modalDiv = document.createElement('div');
    modalDiv.className = 'swatch-modal-container';
    body.appendChild(modalDiv);
  }
  const modal = document.querySelector('.swatch-modal-container');
  const ADD_TO_FAVORITES = 'add';
  const REMOVE_FROM_FAVORITES = 'remove';
  let captionMinimized = false;
  let previousElementInFocus = null;

  const setPreviousElementInFocus = (element) => {
    previousElementInFocus = element;
  };

  const resetFocus = () => {
    if (previousElementInFocus) {
      previousElementInFocus.focus();
    }
  };

  const updateFavoritesButtonLabel = (btn, action) => {
    const assetName = btn.getAttribute('data-colorName');
    if (action === 'remove') {
      return `Remove<span class="sr-only">${assetName} Swatch</span> From Favorites`;
    }
    return `Save<span class="sr-only">${assetName} Swatch</span> To Favorites`;
  };

  const updateFavoritesAriaLabel = (btn, action) => {
    const assetName = btn.getAttribute('data-colorName');
    if (action === 'remove') {
      return `Remove ${assetName} Swatch From Favorites`;
    }
    return `Save ${assetName} Swatch To Favorites`;
  };

  const captionTitlebarClickHandler = () => {
    const caption = modal.querySelector('.gallery-modal-caption');
    const captionBtn = modal.querySelector('.caption-titlebar');
    captionMinimized = !captionMinimized;
    if (!captionMinimized) {
      caption.style.bottom = `-${caption.offsetHeight - 36}px`;
      captionBtn.setAttribute('aria-expanded', 'false');
    } else {
      caption.removeAttribute('style');
      captionBtn.setAttribute('aria-expanded', 'true');
    }
  };

  const removeModal = (event) => {
    let isModalRemoved = false;
    if (modal.firstChild !== null) {
      if (event.target.classList.contains('modal-overlay')) {
        isModalRemoved = true;
      } else if (event.target.classList.contains('close-btn')) {
        isModalRemoved = true;
      }
      if (isModalRemoved) {
        // Caption event handler
        const captionBtn = modal.querySelector('.caption-titlebar');
        captionBtn.removeEventListener('click', captionTitlebarClickHandler);
        modal.removeChild(modal.firstChild);
        document.removeEventListener('click', removeModal);
        resetFocus();
      }
    }
  };

  const addModal = (data) => {
    const isModalAdded = document.querySelector('#swatch-detail-modal');
    if (isModalAdded !== null) {
      return;
    }
    const div = document.createElement('div');
    const compiled = modalTemplateVals(data);
    div.innerHTML = compiled;
    modal.appendChild(div.firstChild);
    // Caption event handler
    const captionBtn = modal.querySelector('.caption-titlebar');
    captionMinimized = true;
    captionBtn.addEventListener('click', captionTitlebarClickHandler);
    document.addEventListener('click', removeModal);
  };

  const getBtnTooltip = btn => (
    btn.parentNode.querySelector('.tooltip')
  );

  const getItemBySwatchKey = (data, id) => (
    data.find(item => id === item['swatch-key'])
  );

  const addToFavoritesEventHandlers = (btn, savedSwatches) => {
    // console.log('swatch-ordering.js, addToFavoritesEventHandlers');
    const id = btn.getAttribute('data-swatchKey');
    // Toggle button to remove state if in swatchbook
    const swatchAsset = getItemBySwatchKey(savedSwatches, id);
    // Get tooltip by data-tooltip-id
    const tooltip = getBtnTooltip(btn);
    let btnLabel = '';
    let ariaLabel = '';
    if (swatchAsset) {
      btn.classList.add('is-active');
      // Add data-asset-id attribute to button
      let swatchId = swatchAsset['digital-swatch-id'];
      // Loading from /hasAssets
      if (!swatchId) {
        swatchId = swatchAsset['swatch-id'];
      }
      btnLabel = updateFavoritesButtonLabel(btn, REMOVE_FROM_FAVORITES);
      ariaLabel = updateFavoritesAriaLabel(btn, REMOVE_FROM_FAVORITES);
      btn.setAttribute('data-assetId', swatchId);
      btn.setAttribute('aria-label', ariaLabel);
      if (tooltip) {
        tooltip.querySelector('p').innerHTML = btnLabel;
      }
    } else {
      btnLabel = updateFavoritesButtonLabel(btn, ADD_TO_FAVORITES);
      ariaLabel = updateFavoritesAriaLabel(btn, ADD_TO_FAVORITES);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-label', ariaLabel);
      if (tooltip) {
        tooltip.querySelector('p').innerHTML = btnLabel;
      }
    }
    // Add/remove swatch event handlers
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      btn.classList.add('btn-disabled');
      if (btn.classList.toString().indexOf('is-active') !== -1) {
        // Remove
        const assetId = btn.getAttribute('data-assetId');
        btnLabel = updateFavoritesButtonLabel(btn, ADD_TO_FAVORITES);
        ariaLabel = updateFavoritesAriaLabel(btn, ADD_TO_FAVORITES);
        removeItemFromAccount('swatch', assetId, () => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-label', ariaLabel);
          if (tooltip) {
            tooltip.querySelector('p').innerHTML = btnLabel;
          }
        });
      } else {
        // Add
        saveItemToAccount(
          'swatch',
          {
            colorName: btn.getAttribute('data-colorName'),
            colorNumber: btn.getAttribute('data-colorNumber'),
            displayMessage: btn.getAttribute('data-displayMessage'),
            newSwatch: btn.getAttribute('data-newSwatch') === 'New!',
            partNumber: btn.getAttribute('data-partNumber'),
            colorRange: btn.getAttribute('data-colorRange'),
            swatchKey: btn.getAttribute('data-swatchKey'),
            tileName: btn.getAttribute('data-tileName'),
            widenUrl: getTruncatedWidenUrl(btn.getAttribute('data-imageUrl')),
          },
          (data) => {
            btn.classList.remove('btn--disabled');
            if (data.success) {
              btnLabel = updateFavoritesButtonLabel(btn, REMOVE_FROM_FAVORITES);
              ariaLabel = updateFavoritesAriaLabel(btn, REMOVE_FROM_FAVORITES);
              btn.classList.add('is-active');
              btn.setAttribute('aria-label', ariaLabel);
              if (tooltip) {
                tooltip.querySelector('p').innerHTML = btnLabel;
              }
              // Set asset id
              btn.setAttribute('data-assetId', data['asset-id']);
            }
          },
        );
      }
    });
  };

  //
  // Add to favorites event handlers
  //
  const addToFavoritesBtns = document.querySelectorAll('.add-to-favorites-btn.swatch-btn');
  if (window.isAuthenticated && addToFavoritesBtns.length > 0) {
    // Get any swatches saved to account
    // before adding add/remove swatch event handlers
    getItemsFromAccount('swatch', (data) => {
      [].map.call(addToFavoritesBtns, (btn) => {
        addToFavoritesEventHandlers(btn, data.swatches);
      });
    });
  } else if (!window.isAuthenticated && addToFavoritesBtns.length > 0) {
    // Skip checking for swatches and just add event handlers
    [].map.call(addToFavoritesBtns, (btn) => {
      addToFavoritesEventHandlers(btn, []);
    });
  }

  //
  // Swatch modal event handlers
  //
  const swatchDetailModalBtns = document.querySelectorAll('.swatch-detail-modal-btn');
  [].map.call(swatchDetailModalBtns, btn => btn.addEventListener('click', () => {
    // const img = btn.querySelector('img');
    // const src = img.getAttribute('src');
    const src = btn.getAttribute('data-imgsrc');
    const item = {
      imageSrc: updateAssetUrlDimensions({
        src,
        width: window.innerHeight,
        height: window.innerHeight,
      }),
      // imageAlt: img.getAttribute('alt'),
      imageAlt: btn.getAttribute('data-imgalt'),
      colorName: btn.getAttribute('data-colorName'),
      productName: btn.getAttribute('data-productName'),
    };
    addModal(item);
    // Update focus
    setPreviousElementInFocus(btn);
    const modalDiv = document.getElementById('swatch-detail-modal');
    modalDiv.focus();
  }));
};
window.InitSwatchOrderingUtils = swatchOrdering;

export default swatchOrdering;
